import { render, staticRenderFns } from "./GlobalCalendarInvitesSettings.vue?vue&type=template&id=01b8cd7e"
import script from "./GlobalCalendarInvitesSettings.vue?vue&type=script&lang=js"
export * from "./GlobalCalendarInvitesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports